import React from 'react';
import { getPolicy, POLICY_IDS, policyPath } from './policyRegistry';
import './legal.css';

export default function PolicyLinks({ className = '', newTab = true, label = 'Policies' }) {
  return (
    <nav className={`legal-links ${className}`.trim()} aria-label={label}>
      {POLICY_IDS.map((policy) => (
        <a
          key={policy}
          href={policyPath(policy)}
          target={newTab ? '_blank' : undefined}
          rel={newTab ? 'noopener noreferrer' : undefined}
          title={newTab ? 'Opens in a new tab' : undefined}
        >
          {getPolicy(policy).title}
        </a>
      ))}
    </nav>
  );
}
